import { apiClient } from './authService';

const dashboardService = {
  // Get all dashboard stats in a single call. `period` = today | 7d | 30d.
  getDashboardData: async (period = '7d') => {
    try {
      const response = await apiClient.get('dashboard/', { params: { period } });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error.response?.data || { message: 'Error fetching dashboard data' };
    }
  }
};

export default dashboardService;
